import React from 'react';
import {
  trans,
  getPagePath,
  useSoyuzLocales,
  useSoyuzFlag
} from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

import { addDataLayerGAEvent } from '@utils/DataLayerGAHandler';

import Footer from '@common/components/Footer';

import ArrangeCallHeroAddon from './ArrangeCallHeroAddon';

import './FooterLandlord.scss';

const FooterLandlord = () => {
  const removeCallMeBackModalFlag = useSoyuzFlag('removeCallMeBackModal');
  const isSpanishLocale = useSoyuzLocales().current === 'es';
  const shouldRenderCallMeBackModal =
    isSpanishLocale && removeCallMeBackModalFlag.isOff();

  const handleGetStartedButton = () => {
    addDataLayerGAEvent('Landlord', 'clickBtn', 'mainFooterBtn');
  };

  return (
    <div className="footer-landlord">
      <div className="footer-landlord__top-wrapper">
        <h2 className="footer-landlord__title">
          {trans('landlord.landing.standard.footer.title')}
        </h2>
        <div className="footer-landlord__cta">
          {shouldRenderCallMeBackModal ? (
            <ArrangeCallHeroAddon className="footer-landlord__button-cta" />
          ) : (
            <Button
              className="footer-landlord__button-cta"
              size="big"
              color="complementary"
              href={getPagePath('externals.landlord-signup')}
              onClick={handleGetStartedButton}
            >
              {trans('landlord.landing.standard.footer.cta')}
            </Button>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FooterLandlord;
